import React, { useEffect, useState } from 'react';
import { OfficerLayout } from '../../components/layout/OfficerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { ClipboardList, FileCheck, TrendingUp, Plus, Upload, Clock, ChevronRight, Sun, Trophy, Target, RefreshCw, Calendar, Award, Wifi, WifiOff, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Modal } from '../../components/ui/Modal';
export function OfficerDashboard() {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showGamification, setShowGamification] = useState(false);
  const [isOnline, setIsOnline] = useState(true);
  // Check online status
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    setIsOnline(navigator.onLine);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => setIsRefreshing(false), 1500);
  };
  const currentDate = new Date().toLocaleDateString('id-ID', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return <OfficerLayout title="Dashboard" data-id="element-3464">
      {/* Sync Indicator */}
      <div className="flex items-center justify-between mb-4 px-1" data-id="element-3465">
        <div className="flex items-center gap-2 text-xs" data-id="element-3466">
          {isOnline ? <span className="flex items-center gap-1 text-green-600 bg-green-50 px-2 py-1 rounded-full" data-id="element-3467">
              <Wifi className="h-3 w-3" data-id="element-3468" /> Online
            </span> : <span className="flex items-center gap-1 text-orange-600 bg-orange-50 px-2 py-1 rounded-full" data-id="element-3469">
              <WifiOff className="h-3 w-3" data-id="element-3470" /> Offline
            </span>}
        </div>
        <button onClick={handleRefresh} className={`text-gray-400 hover:text-primary-600 transition-colors p-1 ${isRefreshing ? 'animate-spin' : ''}`} data-id="element-3471">
          <RefreshCw className="h-4 w-4" data-id="element-3472" />
        </button>
      </div>

      {/* Welcome Section */}
      <div className="mb-6 flex justify-between items-start" data-id="element-3473">
        <div data-id="element-3474">
          <div className="flex items-center gap-2 text-xs text-gray-500 mb-1" data-id="element-3475">
            <Sun className="h-3 w-3 text-orange-500" data-id="element-3476" />
            <span data-id="element-3477">{currentDate}</span>
          </div>
          <h2 className="text-xl font-bold text-gray-900" data-id="element-3478">
            Halo, Pak Budi! 👋
          </h2>
          <p className="text-sm text-gray-600" data-id="element-3479">
            Siap untuk aksi lingkungan hari ini?
          </p>
        </div>
        <div className="p-2 bg-yellow-50 rounded-full cursor-pointer hover:bg-yellow-100 transition-colors" onClick={() => setShowGamification(true)} data-id="element-3480">
          <Trophy className="h-6 w-6 text-yellow-600" data-id="element-3481" />
        </div>
      </div>

      {/* Target Progress Card */}
      <Card className="mb-6 bg-gradient-to-br from-primary-600 to-primary-800 text-white border-none shadow-lg relative overflow-hidden" data-id="element-3482">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-10 -mt-10" data-id="element-3483"></div>
        <CardContent className="p-4 relative z-10" data-id="element-3484">
          <div className="flex justify-between items-center mb-4" data-id="element-3485">
            <h3 className="font-bold flex items-center gap-2" data-id="element-3486">
              <Target className="h-4 w-4" data-id="element-3487" /> Target Mingguan
            </h3>
            <span className="text-xs bg-white/20 px-2 py-1 rounded-full" data-id="element-3488">
              Sisa 3 hari
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-3489">
            <div className="relative h-16 w-16 flex-shrink-0" data-id="element-3490">
              <svg className="h-full w-full transform -rotate-90" viewBox="0 0 36 36" data-id="element-3491">
                <path className="text-primary-900" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="4" strokeOpacity="0.3" data-id="element-3492" />
                <path className="text-white" strokeDasharray="75, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="4" data-id="element-3493" />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center font-bold text-sm" data-id="element-3494">
                75%
              </div>
            </div>
            <div className="flex-1" data-id="element-3495">
              <div className="flex justify-between text-sm mb-1" data-id="element-3496">
                <span data-id="element-3497">Laporan</span>
                <span className="font-bold" data-id="element-3498">15/20</span>
              </div>
              <div className="flex justify-between text-sm mb-1" data-id="element-3499">
                <span data-id="element-3500">Sosialisasi</span>
                <span className="font-bold" data-id="element-3501">3/5</span>
              </div>
              <p className="text-xs text-primary-100 mt-2" data-id="element-3502">
                Hebat! Sedikit lagi mencapai target.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Summary Cards */}
      <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-3503">
        <Card className="border-none shadow-sm bg-blue-50" data-id="element-3504">
          <CardContent className="p-3 flex flex-col items-center text-center" data-id="element-3505">
            <div className="h-8 w-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mb-2" data-id="element-3506">
              <ClipboardList className="h-4 w-4" data-id="element-3507" />
            </div>
            <span className="text-2xl font-bold text-blue-700" data-id="element-3508">3</span>
            <span className="text-[10px] text-blue-600 font-medium" data-id="element-3509">
              Tugas Baru
            </span>
          </CardContent>
        </Card>

        <Card className="border-none shadow-sm bg-green-50" data-id="element-3510">
          <CardContent className="p-3 flex flex-col items-center text-center" data-id="element-3511">
            <div className="h-8 w-8 rounded-full bg-green-100 text-green-600 flex items-center justify-center mb-2" data-id="element-3512">
              <FileCheck className="h-4 w-4" data-id="element-3513" />
            </div>
            <span className="text-2xl font-bold text-green-700" data-id="element-3514">12</span>
            <span className="text-[10px] text-green-600 font-medium" data-id="element-3515">
              Laporan OK
            </span>
          </CardContent>
        </Card>

        <Card className="border-none shadow-sm bg-amber-50" data-id="element-3516">
          <CardContent className="p-3 flex flex-col items-center text-center" data-id="element-3517">
            <div className="h-8 w-8 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mb-2" data-id="element-3518">
              <TrendingUp className="h-4 w-4" data-id="element-3519" />
            </div>
            <span className="text-2xl font-bold text-amber-700" data-id="element-3520">85</span>
            <span className="text-[10px] text-amber-600 font-medium" data-id="element-3521">
              Skor Wilayah
            </span>
          </CardContent>
        </Card>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-3522">
        <Link to="/officer/laporan" data-id="element-3523">
          <Button className="w-full bg-primary-600 hover:bg-primary-700 h-12 shadow-md hover:shadow-lg transition-all active:scale-95" data-id="element-3524">
            <Plus className="mr-2 h-4 w-4" data-id="element-3525" /> Buat Laporan
          </Button>
        </Link>
        <Link to="/officer/proof" data-id="element-3526">
          <Button variant="outline" className="w-full h-12 border-primary-200 text-primary-700 bg-white shadow-sm hover:bg-primary-50 active:scale-95" data-id="element-3527">
            <Award className="mr-2 h-4 w-4" data-id="element-3528" /> Upload Bukti
          </Button>
        </Link>
      </div>

      {/* Event Alert */}
      <Card className="mb-6 border-l-4 border-l-green-500 bg-green-50/50" data-id="element-3529">
        <CardContent className="p-4" data-id="element-3530">
          <div className="flex items-start gap-3" data-id="element-3531">
            <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0" data-id="element-3532">
              <Calendar className="h-5 w-5" data-id="element-3533" />
            </div>
            <div className="flex-1" data-id="element-3534">
              <div className="flex items-center gap-2 mb-1" data-id="element-3535">
                <span className="text-xs font-bold text-green-700 uppercase" data-id="element-3536">
                  Event Aktif
                </span>
                <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse" data-id="element-3537"></span>
              </div>
              <h4 className="font-bold text-gray-900 text-sm" data-id="element-3538">
                HPSN 2025: Atasi Sampah Plastik
              </h4>
              <p className="text-xs text-gray-500 mt-1" data-id="element-3539">
                21 Feb 2025 • Lokasi Anda sudah terdaftar
              </p>
            </div>
            <Link to="/officer/event" data-id="element-3540">
              <Button size="sm" className="bg-green-600 hover:bg-green-700 text-xs h-8" data-id="element-3541">
                Lihat
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>

      {/* Recent Activity */}
      <div className="mb-6" data-id="element-3542">
        <div className="flex items-center justify-between mb-4" data-id="element-3543">
          <h3 className="text-base font-bold text-gray-900" data-id="element-3544">
            Aktivitas Terakhir
          </h3>
          <Link to="/officer/laporan" className="text-xs text-primary-600 font-medium" data-id="element-3545">
            Lihat Semua
          </Link>
        </div>

        <div className="space-y-4" data-id="element-3546">
          {/* Item 1 */}
          <Card className="overflow-hidden active:bg-gray-50 transition-colors cursor-pointer" data-id="element-3547">
            <div className="p-4 flex items-center gap-3" data-id="element-3548">
              <div className="h-10 w-10 rounded-lg bg-green-100 flex items-center justify-center text-green-600 flex-shrink-0" data-id="element-3549">
                <FileCheck className="h-5 w-5" data-id="element-3550" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-3551">
                <h4 className="text-sm font-bold text-gray-900 truncate" data-id="element-3552">
                  Sosialisasi Pilah Sampah
                </h4>
                <p className="text-xs text-gray-500" data-id="element-3553">
                  Kelurahan Sukasari • 2 jam lalu
                </p>
              </div>
              <Badge variant="success" className="text-[10px] px-2" data-id="element-3554">
                Disetujui
              </Badge>
            </div>
          </Card>

          {/* Item 2 */}
          <Card className="overflow-hidden active:bg-gray-50 transition-colors cursor-pointer" data-id="element-3555">
            <div className="p-4 flex items-center gap-3" data-id="element-3556">
              <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600 flex-shrink-0" data-id="element-3557">
                <Clock className="h-5 w-5" data-id="element-3558" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-3559">
                <h4 className="text-sm font-bold text-gray-900 truncate" data-id="element-3560">
                  Monitoring Bank Sampah
                </h4>
                <p className="text-xs text-gray-500" data-id="element-3561">
                  RW 05 Kebon Jeruk • Kemarin
                </p>
              </div>
              <Badge variant="warning" className="text-[10px] px-2" data-id="element-3562">
                Diproses
              </Badge>
            </div>
          </Card>

          {/* Item 3 */}
          <Link to="/officer/proof" data-id="element-3563">
            <Card className="overflow-hidden active:bg-gray-50 transition-colors cursor-pointer" data-id="element-3564">
              <div className="p-4 flex items-center gap-3" data-id="element-3565">
                <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 flex-shrink-0" data-id="element-3566">
                  <Upload className="h-5 w-5" data-id="element-3567" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-3568">
                  <h4 className="text-sm font-bold text-gray-900 truncate" data-id="element-3569">
                    Upload Bukti Tayang
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-3570">
                    Poster HPSN 2025 • 2 hari lalu
                  </p>
                </div>
                <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-3571" />
              </div>
            </Card>
          </Link>
        </div>

        <Button variant="ghost" className="w-full text-xs text-gray-500 mt-2" data-id="element-3572">
          Muat Lebih Banyak
        </Button>
      </div>

      {/* Pending Issues Alert */}
      <Card className="mb-6 border-l-4 border-l-orange-500 bg-orange-50/50" data-id="element-3573">
        <CardContent className="p-4" data-id="element-3574">
          <div className="flex items-center gap-3" data-id="element-3575">
            <AlertTriangle className="h-5 w-5 text-orange-600" data-id="element-3576" />
            <div className="flex-1" data-id="element-3577">
              <p className="text-sm font-medium text-orange-900" data-id="element-3578">
                2 Isu menunggu tindak lanjut
              </p>
              <p className="text-xs text-orange-700" data-id="element-3579">
                Segera eskalasi ke pusat jika perlu
              </p>
            </div>
            <Link to="/officer/isu" data-id="element-3580">
              <Button size="sm" variant="outline" className="border-orange-200 text-orange-700 h-8 text-xs" data-id="element-3581">
                Lihat
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>

      {/* Gamification Modal */}
      <Modal isOpen={showGamification} onClose={() => setShowGamification(false)} title="Pencapaian Saya" size="sm" className="mb-0 rounded-b-none sm:rounded-b-lg sm:mb-auto fixed bottom-0 sm:relative w-full sm:w-auto" data-id="element-3582">
        <div className="text-center mb-6" data-id="element-3583">
          <div className="h-20 w-20 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-600 mx-auto mb-3" data-id="element-3584">
            <Trophy className="h-10 w-10" data-id="element-3585" />
          </div>
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3586">
            Level 3: Officer Andalan
          </h3>
          <p className="text-sm text-gray-500" data-id="element-3587">Total Poin: 1,250 XP</p>
        </div>

        <div className="space-y-4" data-id="element-3588">
          <div className="p-3 bg-gray-50 rounded-lg border flex items-center justify-between" data-id="element-3589">
            <div className="flex items-center gap-3" data-id="element-3590">
              <div className="h-8 w-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-600" data-id="element-3591">
                <Sun className="h-4 w-4" data-id="element-3592" />
              </div>
              <div data-id="element-3593">
                <p className="text-sm font-medium text-gray-900" data-id="element-3594">
                  Daily Streak
                </p>
                <p className="text-xs text-gray-500" data-id="element-3595">
                  Aktif 5 hari berturut-turut
                </p>
              </div>
            </div>
            <span className="font-bold text-orange-600" data-id="element-3596">5 Hari</span>
          </div>

          <div className="p-3 bg-gray-50 rounded-lg border flex items-center justify-between" data-id="element-3597">
            <div className="flex items-center gap-3" data-id="element-3598">
              <div className="h-8 w-8 bg-green-100 rounded-full flex items-center justify-center text-green-600" data-id="element-3599">
                <FileCheck className="h-4 w-4" data-id="element-3600" />
              </div>
              <div data-id="element-3601">
                <p className="text-sm font-medium text-gray-900" data-id="element-3602">
                  Laporan Valid
                </p>
                <p className="text-xs text-gray-500" data-id="element-3603">Total laporan disetujui</p>
              </div>
            </div>
            <span className="font-bold text-green-600" data-id="element-3604">42</span>
          </div>

          <div className="p-3 bg-gray-50 rounded-lg border flex items-center justify-between" data-id="element-3605">
            <div className="flex items-center gap-3" data-id="element-3606">
              <div className="h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600" data-id="element-3607">
                <Award className="h-4 w-4" data-id="element-3608" />
              </div>
              <div data-id="element-3609">
                <p className="text-sm font-medium text-gray-900" data-id="element-3610">
                  Bukti Tayang
                </p>
                <p className="text-xs text-gray-500" data-id="element-3611">
                  Total bukti diverifikasi
                </p>
              </div>
            </div>
            <span className="font-bold text-blue-600" data-id="element-3612">8</span>
          </div>
        </div>
      </Modal>
    </OfficerLayout>;
}